import React from 'react';

import component from '../component';


export const Close = component('Close', function(props) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" {...props}>
      <g transform="translate(-1041.000000, -193.000000)">
        <path d="M1055,194.41 L1053.59,193 L1048,198.59 L1042.41,193 L1041,194.41 L1046.59,200 L1041,205.59 L1042.41,207 L1048,201.41 L1053.59,207 L1055,205.59 L1049.41,200 L1055,194.41" id="Imported-Layers" />
      </g>
    </svg>
  );
});

export const ArrowRight = component('ArrowRight', function({...props}) {

  return (
    <svg width='8' height='12' {...props}>
      <path d='M5.17 6L.59 1.41 2 0l6 6-6 6-1.41-1.41L5.17 6z'/>
    </svg>
  );

});

export const ArrowUp = component('ArrowUp', function({...props}) {

  return (
    <svg width='8' height='12' {...props}>
      <path d="M1.41 7.41L6 2.83l4.59 4.58L12 6 6 0 0 6l1.41 1.41" />
    </svg>
  );

});

export const Skype = component('Skype', function({...props}) {

  return (
    <svg width='16' height='16' viewBox='0 0 16 16' {...props}>
      <path d='M15.488 9.653c.115-.518.176-1.056.176-1.607 0-4.136-3.405-7.49-7.606-7.49-.443 0-.878.038-1.3.11C6.078.246 5.274 0 4.41 0 1.976 0 0 1.945 0 4.343c0 .802.222 1.552.607 2.197-.1.487-.155.99-.155 1.506 0 4.136 3.405 7.49 7.606 7.49.476 0 .942-.044 1.393-.127.63.32 1.33.51 2.09.51 2.44 0 4.41-1.95 4.41-4.34 0-.7-.16-1.35-.46-1.93zm-3.53 1.972c-.35.49-.87.88-1.544 1.154-.667.27-1.467.41-2.377.41-1.093 0-2.008-.19-2.723-.57-.51-.27-.933-.64-1.252-1.1-.324-.46-.487-.916-.487-1.355 0-.275.106-.513.317-.707.208-.19.475-.29.794-.29.26 0 .486.08.67.23.175.147.325.36.446.64.134.306.28.56.437.765.14.193.36.36.63.484.27.13.65.193 1.1.193.63 0 1.14-.13 1.53-.393.38-.25.56-.56.56-.93 0-.3-.098-.53-.296-.713-.207-.19-.48-.34-.81-.44-.347-.106-.816-.22-1.397-.34-.79-.166-1.46-.363-1.99-.586-.543-.23-.983-.544-1.305-.94-.326-.4-.49-.908-.49-1.5 0-.567.172-1.077.515-1.517.34-.434.837-.773 1.477-1.01.63-.23 1.382-.343 2.232-.343.68 0 1.273.076 1.77.23.507.152.93.36 1.26.615.33.257.58.533.74.82.16.287.24.575.24.853 0 .265-.108.51-.315.72-.205.212-.47.32-.78.32-.28 0-.5-.068-.653-.2-.143-.125-.29-.318-.454-.596-.19-.36-.42-.64-.683-.836-.253-.19-.68-.288-1.27-.288-.543 0-.986.105-1.315.32-.317.202-.47.44-.47.715 0 .17.05.313.15.436.11.13.26.247.454.34.2.1.406.18.612.236.21.06.563.146 1.05.257.615.13 1.18.274 1.68.432.51.16.945.355 1.302.584.363.23.65.53.856.89.21.36.31.802.31 1.32 0 .614-.18 1.18-.53 1.67z'
        fill='#466384' fillRule='evenodd' />
    </svg>
  )

});

export const Magnifier = component('Magnifier', function({...props}) {

  return (
    <svg width='18' height='18' {...props}>
      <path d='M12.5 11h-.79l-.28-.27C12.41 9.59 13 8.11 13 6.5 13 2.91 10.09 0 6.5 0S0 2.91 0 6.5 2.91 13 6.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L17.49 16l-4.99-5zm-6 0C4.01 11 2 8.99 2 6.5S4.01 2 6.5 2 11 4.01 11 6.5 8.99 11 6.5 11z' />
    </svg>
  );

});

export const PlusBig = component('PlusBig', function({...props}) {

  return (
    <svg width='18' height='18' {...props}>
      <path d="M100 48.5H52V.5h-4v48H0v4h48v48h4v-48h48v-4" fillRule="evenodd"/>
    </svg>
  );

});

export const CancelSmall = component('CancelSmall', function({...props}) {

  return (
    <svg width='20' height='20' {...props}>
      <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L14.9 16.31C13.55 17.37 11.85 18 10 18zm6.31-3.1L5.1 3.69C6.45 2.63 8.15 2 10 2c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z" />
    </svg>
  );

});

export const CancelBig = component('CancelBig', function({...props}) {

  return (
    <svg width='96' height='95' {...props}>
      <path d="M48 0C21.547 0 0 21.31 0 47.473c0 26.162 21.547 47.472 48 47.472s48-21.31 48-47.472C96 21.31 74.453 0 48 0zM15.68 76.273c-6.933-7.596-11.2-17.724-11.2-28.8C4.48 23.736 24 4.43 48 4.43c11.2 0 21.44 4.22 29.12 11.078L15.68 76.273zm64.64-57.6c6.933 7.7 11.2 17.723 11.2 28.8C91.52 71.21 72 90.513 48 90.513c-11.2 0-21.333-4.218-29.12-11.076l61.44-60.764z" />
    </svg>
  );

});

export const Mail = component('Mail', function({...props}) {

  return (
    <svg width='56' height='58' {...props}>
      <g fillRule="evenodd">
        <path d="M41.467 19.38h-27.21c-.36 0-.653.29-.653.652 0 .36.29.652.652.652h27.21c.36 0 .653-.29.653-.652 0-.36-.3-.652-.66-.652m-1.5 4.497H15.75c-.36 0-.652.29-.652.652 0 .36.29.65.652.65h24.212c.36 0 .652-.29.652-.65 0-.36-.293-.66-.653-.66M8.32 8.06h39.1c.36 0 .652-.29.652-.652 0-.36-.29-.65-.653-.65H8.32c-.36 0-.654.29-.654.65 0 .36.293.653.653.653m0 4.5h39.1c.36 0 .65-.29.65-.65 0-.36-.29-.65-.653-.65H8.32c-.36 0-.654.29-.654.65 0 .36.293.65.653.65"/>
        <path d="M55.785 18.77c0-.004-.003-.007-.003-.01 0-.012-.01-.022-.01-.034 0-.017.01-.032.006-.05-.007-.044-.038-.076-.054-.118-.017-.048-.024-.098-.052-.14-.004-.007-.002-.015-.007-.022-.007-.01-.018-.015-.025-.024-.015-.02-.034-.03-.05-.048-.045-.045-.09-.088-.143-.117-.006-.003-.01-.01-.015-.014-.015-.008-.033-.004-.048-.01l-.007-.002c-.015 0-.024-.02-.04-.02L51.84 17V1.008c0-.36-.298-.65-.66-.65H4.81c-.36 0-.65.29-.65.65V16.96L.656 18.155c-.016.005-.025.02-.04.028-.016.007-.034.002-.05.01-.04.02-.062.062-.097.09-.05.037-.09.07-.13.116-.04.04-.05.1-.07.15-.02.04-.05.07-.06.12 0 .01.003.03.002.04 0 .014-.013.03-.013.043v34.88c0 1.152.51 2.252 1.395 3.015.73.633 1.654.982 2.602.982h47.57c.943 0 1.87-.35 2.6-.98.888-.768 1.397-1.868 1.397-3.017V18.77zm-1.304 1.258v33.62c0 .607-.21 1.194-.59 1.67L29.14 37.883l4.226-2.978h.002l1.088-.767c.137-.04.25-.122.332-.234L51.57 22.082v-.002l1.79-1.26 1.125-.792zM28 37.086l-4.13-2.91h8.263L28 37.086zm5.983-4.214H22.018l-4.536-3.195h21.036l-4.535 3.195zM53.7 18.982l-1.86 1.312v-1.93l1.86.62zM50.538 1.66v19.554l-.61.43-8.522 6.003-1.036.73H15.63L5.46 21.214V1.658h45.075zM4.16 20.293l-1.87-1.317 1.87-.637v1.95zm.055 36.048c-.644 0-1.25-.22-1.752-.66-.6-.51-.944-1.25-.944-2.03V20.03l.2.144 2.71 1.91v.002l5.83 4.107 10.95 7.716c.08.11.19.19.33.23l1.08.76 30.15 21.24c-.315.13-.654.2-1.003.2H4.212z"/>
      </g>
    </svg>
  );

});

export const Clock = component('Clock', function({...props}) {

  return (
    <svg width='20' height='20' {...props}>
      <g fillRule="evenodd">
        <path d="M10 18.002c-4.42 0-8-3.582-8-8 0-4.42 3.58-8 8-8s8 3.58 8 8c0 4.418-3.58 8-8 8m-.01-18C4.473 0 0 4.48 0 10s4.472 10 9.99 10C15.52 20 20 15.522 20 10 20 4.48 15.52 0 9.99 0"/>
        <path d="M10.5 5H9v6l5.25 3.15.75-1.23-4.5-2.67V5"/>
      </g>
    </svg>
  );

});

export const LogoFacebook = component('LogoFacebook', function({className, stroke, fill}) {

  return (
    <svg width="50" height="50" lassName={className}>
      <g fill="none" fillRule="evenodd">
        <circle stroke={stroke} strokeWidth="2" opacity=".4" cx="24" cy="24" r="23"/>
        <path fill={fill} d="M18 24.877V21.32h3.128V18.7c0-1.49.426-2.647 1.276-3.468.85-.82 1.983-1.232 3.398-1.232 1.203 0 2.135.048 2.797.144v3.173h-1.93c-.703 0-1.177.145-1.423.433-.246.288-.37.72-.37 1.298v2.272h3.596l-.48 3.557H24.88V34h-3.753v-9.123H18z"/>
      </g>
    </svg>
  );

});

export const LogoVkontakte = component('LogoVkontakte', function({className, stroke, fill}) {

  return (
    <svg width="50" height="50" className={className}>
      <g fill="none" fillRule="evenodd">
        <circle stroke={stroke} className="Svg-Circle" strokeWidth="2" opacity=".4" cx="24" cy="24" r="23"/>
        <path fill={fill} d="M23.51 32.526h1.528s.462-.05.698-.305c.217-.23.21-.67.21-.67s-.03-2.05.922-2.35c.938-.3 2.143 1.98 3.42 2.86.965.666 1.7.52 1.7.52l3.414-.047s1.786-.11.94-1.515c-.07-.114-.494-1.038-2.54-2.936-2.14-1.99-1.854-1.666.725-5.104 1.57-2.093 2.198-3.37 2.002-3.918-.19-.522-1.35-.384-1.35-.384l-3.845.025s-.285-.04-.496.087c-.207.124-.34.413-.34.413s-.608 1.62-1.42 2.996c-1.71 2.906-2.396 3.06-2.676 2.88-.65-.42-.49-1.69-.49-2.592 0-2.818.427-3.992-.83-4.296-.42-.1-.728-.168-1.797-.18-1.37-.013-2.53.005-3.19.327-.437.214-.775.69-.57.718.255.036.83.158 1.135.57.394.54.38 1.74.38 1.74s.226 3.32-.53 3.73c-.517.28-1.23-.294-2.754-2.93-.78-1.35-1.374-2.845-1.374-2.845s-.113-.277-.317-.427c-.246-.18-.59-.236-.59-.236l-3.654.023s-.55.014-.75.253c-.18.21-.015.65-.015.65s2.86 6.69 6.1 10.063c2.97 3.093 6.34 2.89 6.34 2.89"/>
      </g>
    </svg>
  );

});

export const CheckedSmall = component('CheckedSmall', function({...props}) {
  return (
    <svg width="18" height="14" {...props}>
      <g transform="translate(-1102.000000, -1652.000000)" fill="#0B0B0A">
        <path d="M1107.59,1662.58 L1103.42,1658.41 L1102,1659.82 L1107.59,1665.41 L1119.59,1653.41 L1118.18,1652 L1107.59,1662.58"></path>
      </g>
    </svg>
  );
});

export const Warning = component('Warning', function({...props}) {
  return (
    <svg width="128" height="128" {...props}>
      <g id="Design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Pop-up-Copy-2" transform="translate(-656.000000, -226.000000)" fill="#E2001D">
          <g id="Imported-Layers" transform="translate(656.000000, 226.000000)">
            <path d="M64,30.4761905 C62.3177143,30.4761905 60.952381,31.8415238 60.952381,33.5238095 L60.952381,76.1904762 C60.952381,77.8727619 62.3177143,79.2380952 64,79.2380952 C65.6822857,79.2380952 67.047619,77.8727619 67.047619,76.1904762 L67.047619,33.5238095 C67.047619,31.8415238 65.6822857,30.4761905 64,30.4761905" id="Fill-1"></path>
            <path d="M64,89.9047619 C62.3177143,89.9047619 60.952381,91.2700952 60.952381,92.952381 L60.952381,99.047619 C60.952381,100.729905 62.3177143,102.095238 64,102.095238 C65.6822857,102.095238 67.047619,100.729905 67.047619,99.047619 L67.047619,92.952381 C67.047619,91.2700952 65.6822857,89.9047619 64,89.9047619" id="Fill-2"></path>
            <path d="M64,0 C29.3089524,0 0,29.3074286 0,64 C0,98.6925714 29.3089524,128 64,128 C98.6910476,128 128,98.6925714 128,64 C128,29.3074286 98.6910476,0 64,0 L64,0 Z M64,121.904762 C32.6125714,121.904762 6.0952381,95.3874286 6.0952381,64 C6.0952381,32.6125714 32.6125714,6.0952381 64,6.0952381 C95.3874286,6.0952381 121.904762,32.6125714 121.904762,64 C121.904762,95.3874286 95.3874286,121.904762 64,121.904762 L64,121.904762 Z" id="Fill-3"></path>
          </g>
        </g>
      </g>
    </svg>
  );
});

export const Caution = component('Caution', function({...props}) {
  return (
    <svg width="128" height="128" {...props}>
      <g id="Design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Pop-up-Copy-2" transform="translate(-656.000000, -226.000000)" fill="#ffa800">
          <g id="Imported-Layers" transform="translate(656.000000, 226.000000)">
            <path d="M64,30.4761905 C62.3177143,30.4761905 60.952381,31.8415238 60.952381,33.5238095 L60.952381,76.1904762 C60.952381,77.8727619 62.3177143,79.2380952 64,79.2380952 C65.6822857,79.2380952 67.047619,77.8727619 67.047619,76.1904762 L67.047619,33.5238095 C67.047619,31.8415238 65.6822857,30.4761905 64,30.4761905" id="Fill-1"></path>
            <path d="M64,89.9047619 C62.3177143,89.9047619 60.952381,91.2700952 60.952381,92.952381 L60.952381,99.047619 C60.952381,100.729905 62.3177143,102.095238 64,102.095238 C65.6822857,102.095238 67.047619,100.729905 67.047619,99.047619 L67.047619,92.952381 C67.047619,91.2700952 65.6822857,89.9047619 64,89.9047619" id="Fill-2"></path>
            <path d="M64,0 C29.3089524,0 0,29.3074286 0,64 C0,98.6925714 29.3089524,128 64,128 C98.6910476,128 128,98.6925714 128,64 C128,29.3074286 98.6910476,0 64,0 L64,0 Z M64,121.904762 C32.6125714,121.904762 6.0952381,95.3874286 6.0952381,64 C6.0952381,32.6125714 32.6125714,6.0952381 64,6.0952381 C95.3874286,6.0952381 121.904762,32.6125714 121.904762,64 C121.904762,95.3874286 95.3874286,121.904762 64,121.904762 L64,121.904762 Z" id="Fill-3"></path>
          </g>
        </g>
      </g>
    </svg>
  );
})

export const Check = component('Check', function({...props}) {
  return (
    <svg width="121px" height="126px" viewBox="0 0 121 126" >
      <g id="Design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Pop-up-Copy-4" transform="translate(-659.000000, -227.000000)" fill="#7D91A8">
          <g id="Imported-Layers" transform="translate(659.555556, 227.000000)">
            <path d="M104,40.4222222 C102.933333,40.4222222 102.222222,41.1333333 102.222222,42.2 L102.222222,103.177778 C102.222222,113.488889 93.8666667,121.666667 83.5555556,121.666667 L22.5777778,121.666667 C12.2666667,121.666667 3.91111111,113.311111 3.91111111,103 L3.91111111,42.2 C3.91111111,31.8888889 12.2666667,23.5333333 22.5777778,23.5333333 L83.5555556,23.5333333 C86.4,23.5333333 89.0666667,24.0666667 91.5555556,25.3111111 C92.4444444,25.6666667 93.5111111,25.3111111 93.8666667,24.4222222 C94.2222222,23.5333333 93.8666667,22.4666667 92.9777778,22.1111111 C89.9555556,20.6888889 86.7555556,19.9777778 83.5555556,19.9777778 L22.5777778,19.9777778 C10.3111111,19.9777778 0.355555556,29.9333333 0.355555556,42.2 L0.355555556,103.177778 C0.355555556,115.444444 10.3111111,125.4 22.5777778,125.4 L83.5555556,125.4 C95.8222222,125.4 105.777778,115.444444 105.777778,103.177778 L105.777778,42.2 C105.777778,41.1333333 104.888889,40.4222222 104,40.4222222" id="Fill-1"></path>
            <path d="M119.644444,0.6 C118.755556,0.0666666667 117.688889,0.244444444 117.155556,1.13333333 L54.9333333,96.9555556 L18.6666667,58.9111111 C17.9555556,58.2 16.8888889,58.2 16.1777778,58.9111111 C15.4666667,59.6222222 15.4666667,60.6888889 16.1777778,61.4 L54.0444444,101.044444 C54.4,101.4 54.9333333,101.577778 55.2888889,101.577778 L55.4666667,101.577778 C56,101.577778 56.5333333,101.222222 56.7111111,100.688889 L120.177778,2.91111111 C120.711111,2.2 120.533333,1.13333333 119.644444,0.6" id="Fill-2"></path>
          </g>
        </g>
      </g>
    </svg>
  );
});



export const KBLogo = component('KBLogo', function({...props}) {
  return (
    <svg version="1" xmlns="http://www.w3.org/2000/svg" width="64" height="9" viewBox="0 0 256 36">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M232 20h12v-4h-12v4zm16 4h-16v8h12v-4h4v4h-4v4h-12v-4h-4V16h4v-4h12v4h4v8zM224 0v36h-4V0h4zm-8 16h-4v16h4v4h-4v-4h-4V16h-4v-4h4V4h4v8h4v4zm-16 0v8h-16v8h12v-4h4v4h-4v4h-12v-4h-4V16h4v-4h12v4h4zm-4 0h-12v4h12v-4zm-20 0v8h-16v8h12v-4h4v4h-4v4h-12v-4h-4V16h4v-4h12v4h4zm-4 0h-12v4h12v-4zm-24 0h4v16h-4v4h-16V0h4v12h12v4zm-12 0v16h12V16h-12zm-24-4h12V0h4v36h-16v-4h-4V16h4v-4zm0 4v16h12V16h-12zm-20 0v4h-4v16h-4V12h4v4h4v-4h8v4h4v20h-4V16h-8zM80 4h-4V0h4v4zm0 8v24h-4V12h4zm-12 0v4h-4v4h-4v4h4v4h4v4h4v4h-4v-4h-4v-4h-4v-4h-4v12h-4V0h4v20h4v-4h4v-4h4zM32 8h-4v4h-4V8h4V0h4v8zm0 12h4v4h-4v-4h-8v-4h8v4zm-12-8h-4V8h-4V0h4v8h4v4zm-8 4h8v4h-8v4H8v-4h4v-4zm16 8v4h4v8h-4v-8h-4v-4h4zm-8 0v4h-4v8h-4v-8h4v-4h4z"/>
    </svg>
  );
});


export const SlicedHamburger = component('SlicedHamburger', function ({...props}) {
  return (
    <svg width="18px" height="10px" viewBox="0 0 18 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-331.000000, -1215.000000)">
          <g transform="translate(328.000000, 1208.000000)">
            <g>
              <path d="M0,0 L24,0 L24,24 L0,24 L0,0 Z"></path>
              <path d="M3,13 L5,13 L5,11 L3,11 L3,13 L3,13 Z M3,17 L5,17 L5,15 L3,15 L3,17 L3,17 Z M3,9 L5,9 L5,7 L3,7 L3,9 L3,9 Z M7,13 L21,13 L21,11 L7,11 L7,13 L7,13 Z M7,17 L21,17 L21,15 L7,15 L7,17 L7,17 Z M7,7 L7,9 L21,9 L21,7 L7,7 L7,7 Z" fill="#7D91A8"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
});



// WEBPACK FOOTER //
// ./src/components/icons/index.js